/** Query parameter (and cookie) that picks the cinema the local demo domain shows. */
export const DEMO_CINEMA_PARAM = 'demo-cinema';

/**
 * Query parameter (and session cookie) that draws one film's campaign banner on a cinema website, for the sales demo
 * of that film. Honored only inside a frame, and only alongside `SALES_DEMO_FRAME_PARAM`: a cinema's real visitors
 * must never meet an ad its operator never booked.
 */
export const DEMO_AD_PARAM = 'demo-ad';

/**
 * Where a sales demo website opens. Demo domains (`<slug>.demo.cineamo.dev`) are served by the staging deployment,
 * which does not know a cinema that exists only in a local database; locally the moviehouse demo domain shows that
 * cinema instead. `NEXT_PUBLIC_ENV_LOCAL_DEMO_WEBSITE_HOST` is only set when the app runs on a `.test` domain.
 */
export function demoWebsiteUrl(domain: string, cinemaId: number): string {
    const localHost = process.env.NEXT_PUBLIC_ENV_LOCAL_DEMO_WEBSITE_HOST;
    return localHost ? `https://${localHost}/?${DEMO_CINEMA_PARAM}=${cinemaId}` : `https://${domain}/`;
}
